import React from "react"
import { withRouter } from "react-router-dom"
import { Loading } from "./Loading"
import { GetDataStoredInDatasetAsync } from "./fetchData"
import Select from "react-select"
import { SheetMenuContainer } from "./SheetMenuContainer"
import cn from "classnames"
import "./Toolbars.css"
import Linkify from "linkifyjs/react"



function VPToolbarMenu(props) {
	const id = props
	const ProductName = props.ProductName
	const FullProductPath = props.FullProductPath
	const toolbar = props.toolbarType
	const TweetLengthSummary = props.shortSummary
	const ContactName=props.ContactName
	const ContactInfo= props.ContactInfo
	const ReportDate= props.ReportDate
	switch(toolbar){
	case "Dashboard":
			return (
				<div className="VPToolbarMenu SpaceContent">
					<div className="ThreeTextSection">
						<div className="TextContainer">
							<span className="WelcomeText">Welcome to your {ProductName} Dashboard. </span>
							<span className="TweetLengthSummary"><Linkify>{TweetLengthSummary}</Linkify>
							</span>
						</div>
					</div>
					<div className="ThreeTextSection">
						<div className="ToolbarIconContainer">
							<div className="vp-icon-32 LargePersonIcon"></div>
						</div>
						<div className="TextContainer">
							<span className="personLabel">Your Analyst</span>
						</div>
						<div className="TextContainer">
							<div className="AnalystName">{ContactName}</div>
							<div className="AnalystContact">{ContactInfo}</div>
						</div>
					</div>
					<div className="ThreeTextSection">
						<div className="ToolbarIconContainer">
							<div className="CalendarIcon"></div>
						</div>
						<div className="TextContainer">
							<div className="DateLabel">Report Date</div>
							<div className="ReportDate">{ReportDate}</div>
						</div>
					</div>
				</div>
			)
		/*case 'list':
			return (
				<div className="VPToolbarMenu">
					<div className="ButtonSection">
						<div className="ButtonContainer" onClick={() => FindInList()}>
							<div className="vp-icon-32 vp-icon-Home-32 vp-icon-find"></div>
							<span className="buttonLabel">Find</span>
						</div>
						<div className="ButtonContainer">
							<div className="vp-icon-32 vp-icon-Home-32 vp-icon-selectall"></div>
							<span className="buttonLabel">Select All</span>
						</div>
					</div>
				</div>
			)
		case 'matrix':
			return (
				<div className="VPToolbarMenu">
					<div className="ButtonSection">
						<div className="ButtonContainer">
							<div className="vp-icon-32 vp-icon-Home-32 vp-icon-find"></div>
							<span className="buttonLabel">Find</span>
						</div>
						<div className="ButtonContainer">
							<div className="vp-icon-32 vp-icon-Home-32 vp-icon-selectall"></div>
							<span className="buttonLabel">Select All</span>
						</div>
					</div>
				</div>
			)		*/
	case "browser":
			return (
				<div className="VPToolbarMenuHidden">
				</div>
			)		
		default:
			return (
				<div className="VPToolbarMenuHidden">
				</div>
			)
	}
}
function FindInList(){
	alert("List")
}
class Toolbars extends React.PureComponent {

	constructor(props) {
		super(props)
	  const FieldArray = props.FieldArray
	  const DetailFields = props.DetailFields
	  const TitleViewField = props.TitleViewField
	  const appURL = props.appURL
		this.myRef = React.createRef()
	  this.state = {
		loading: true,
		sheetNames: {},
		datasetID: props.datasetID,
		datasetDetails: props.datasetDetails,
		FieldArray: FieldArray,
		DetailFields: DetailFields,
		TitleViewField: TitleViewField,
		appURL: appURL,
		defaultSheet: {},
		datasetName: "",
		RecordCount: 0,
		companyName: "",
		UserName: "",
		selectedSheetID: props.selectedSheetID,
		toolbarType: "default",
		classNames: "ToolbarContainer",
		viewID: 0,
		ContactName: "",
		ContactInfo: "",
		ReportDate: "",
		shortSummary: "",
		ProductName: props.ProductName,
		FullProductPath: props.FullProductPath

	  }
		this.ChangeSelectedSheet = this.ChangeSelectedSheet.bind(this)
		this.FirstSheet = this.FirstSheet.bind(this)
		this.PreviousSheet = this.PreviousSheet.bind(this)
		this.NextSheet = this.NextSheet.bind(this)
		this.LastSheet = this.LastSheet.bind(this)
	  this.OpenHelp = this.OpenHelp.bind(this)
	  this.GetNewAppData = this.GetNewAppData.bind(this)
	}    
	ChangeSelectedSheet(target){ 
		this.setState({
			selectedSheetID: target
		})
		this.props.history.push({
			pathname: target.value,
			state: { ViewNote: target.Note }
		})
	}
	FirstSheet(){ 
		const node = this.myRef.current
		const selected = node.select.state.selectValue[0].index
		
		if (selected > 0){
			this.setState({
				selectedSheetID: node.props.options[0]
			})
			this.props.history.push({
				pathname: node.props.options[0].value,
				state: { ViewNote: node.props.options[0].Note }
			})
		}
	}
	PreviousSheet(){ 
		const node = this.myRef.current
		const selected = node.select.state.selectValue[0].index
		if (selected > 0){
			const newval = selected - 1
			this.setState({
				selectedSheetID: node.props.options[newval]
			})
			this.props.history.push({
				pathname: node.props.options[newval].value,
				state: { ViewNote: node.props.options[newval].Note }
			})
		}
	}
	NextSheet(){ 
		const node = this.myRef.current
		const length = node.props.options.length - 1
		const selected = node.select.state.selectValue[0].index
		if (selected < length){
			const newval = selected + 1
			this.setState({
				selectedSheetID: node.props.options[newval]
			})
			this.props.history.push({
				pathname: node.props.options[newval].value,
				state: { ViewNote: node.props.options[newval].Note }
			})
		}
	}
	LastSheet(){ 
		const node = this.myRef.current
		const length = node.props.options.length - 1
		const selected = node.select.state.selectValue[0].index
		if (selected < length){
			this.setState({
				selectedSheetID: node.props.options[length]
			})
			this.props.history.push({
				pathname: node.props.options[length].value,
				state: { ViewNote: node.props.options[length].Note }
			})
		}
	}
	fetchData(appURL, datasetID, sheetData){
		var index = 0
		var sheets = [{
			label: <span><div className="vp-icon-16 vp-icon-Report-16 vp-icon-dashboard-16" style={{display: "inline-block"}}></div><span>Dashboard</span></span>,
			value: "/Dashboard/" + datasetID,
			index: index,
			Note: ""
		}]
		var datasetName = ""

		for (var dataset in sheetData){
			datasetName = dataset
			var sheetNames = JSON.parse(sheetData[dataset].SheetName)
			var RecordCount = JSON.parse(sheetData[dataset].RecordCount).toLocaleString()
		}
		for (var sheet in sheetNames) {
			index += 1
			if (String(sheetNames[sheet].Type) === "List"){
				var sheetLabel = <span><div className="vp-icon-16 vp-icon-Home-16 vp-icon-list-16" style={{display: "inline-block"}}></div><span>{sheetNames[sheet].Name[0]}</span></span>
				if (sheetNames[sheet].Note[0] !== ""){
					sheetLabel = <span><div className="vp-icon-16 vp-icon-Home-16 vp-icon-list-16" style={{display: "inline-block"}}></div><span>{sheetNames[sheet].Name[0]}</span><div className="vp-icon-16 vp-icon-Note-16" style={{display: "inline-block"}} title={sheetNames[sheet].Note[0]}></div></span>
				}
				sheets.push({
					label: sheetLabel,
					value: "/list/" + datasetID + "/" + sheetNames[sheet].ID[0],
					index: index,
					Note: sheetNames[sheet].Note[0]
				})
			}
			else if (String(sheetNames[sheet].Type) === "Matrix"){
				var sheetLabel = <span><div className="vp-icon-16 vp-icon-Home-16 vp-icon-matrix-16" style={{display: "inline-block"}}></div><span>{sheetNames[sheet].Name[0]}</span></span>
				if (sheetNames[sheet].Note[0] !== ""){
					sheetLabel = <span><div className="vp-icon-16 vp-icon-Home-16 vp-icon-matrix-16" style={{display: "inline-block"}}></div><span>{sheetNames[sheet].Name[0]}</span><div className="vp-icon-16 vp-icon-Note-16" style={{display: "inline-block"}} title={sheetNames[sheet].Note[0]}></div></span>
				}
				sheets.push({
					label: sheetLabel,
					value: "/matrix/" + datasetID + "/" + sheetNames[sheet].ID[0],
					index: index,
					Note: sheetNames[sheet].Note[0]
				})}
			else if (String(sheetNames[sheet].Type) === "Browser"){
				if (sheetNames[sheet].Name[0] === "Summary"){
					var sheetLabel = <span><div className="vp-icon-16 vp-icon-Home-16 vp-icon-summary-16" style={{display: "inline-block"}}></div><span>{sheetNames[sheet].Name[0]}</span></span>
					if (sheetNames[sheet].Note[0] !== ""){
						sheetLabel = <span><div className="vp-icon-16 vp-icon-Home-16 vp-icon-summary-16" style={{display: "inline-block"}}></div><span>{sheetNames[sheet].Name[0]}</span><div className="vp-icon-16 vp-icon-Note-16" style={{display: "inline-block"}} title={sheetNames[sheet].Note[0]}></div></span>
					}
					sheets.push({
						label: sheetLabel,
						value: "/summary/" + datasetID,
						index: index,
						Note: sheetNames[sheet].Note[0]
					})
				}
				else {
					var sheetLabel = <span><div className="vp-icon-16 vp-icon-Report-16 vp-icon-browser-16" style={{display: "inline-block"}}></div><span>{sheetNames[sheet].Name[0]}</span></span>
					if (sheetNames[sheet].Note[0] !== ""){
						sheetLabel = <span><div className="vp-icon-16 vp-icon-Report-16 vp-icon-browser-16" style={{display: "inline-block"}}></div><span>{sheetNames[sheet].Name[0]}</span><div className="vp-icon-16 vp-icon-Note-16" style={{display: "inline-block"}} title={sheetNames[sheet].Note[0]}></div></span>
					}
					sheets.push({
						label: sheetLabel,
						value: "/browser/" + datasetID + "/" + sheetNames[sheet].ID[0],
						index: index,
						Note: sheetNames[sheet].Note[0]
					})
					
				}
			}
			else {

				sheets.push({
					label: sheetNames[sheet].Name[0],
					value: sheetNames[sheet].ID[0],
					index: index,
					Note: sheetNames[sheet].Note[0]
				})
			}
		}
		this.setState({
			sheetNames: sheets,
			loading: false,
			selectedSheetID: sheets[0],
			datasetName: datasetName,
			RecordCount: RecordCount
		})
		GetDataStoredInDatasetAsync(appURL, datasetID, "ShortSummary")
		.then((data) => {
			let shortSummary = ""
			if (data !== "" && data !== "Unable to GetDataStoredInDataset") {
					shortSummary = data
			}
			this.setState({
				shortSummary: shortSummary
			})
		})
		GetDataStoredInDatasetAsync(appURL, datasetID, "ContactName", "Text")
		.then((data) => {
			this.setState({
				ContactName: data
			})
		})
		GetDataStoredInDatasetAsync(appURL, datasetID, "ContactInfo", "Text")
		.then((data) => {
			this.setState({
				ContactInfo: data
			})
		})
		GetDataStoredInDatasetAsync(appURL, datasetID, "ReportDate", "Text")
		.then((data) => {
			this.setState({
				ReportDate: data
			})
		})
		GetDataStoredInDatasetAsync(appURL, datasetID, "ClientUserName")
		.then((data) => {
			let userName = ""
			if (data !== "" && data !== "Unable to GetDataStoredInDataset") {
					userName = data
			}
			this.setState({
				UserName: userName
			})
		})
	  }
	  componentDidMount(){
		this.fetchData(this.state.appURL, this.state.datasetID, this.state.datasetDetails)
	  }
	  componentDidUpdate(prevProps, prevState){
		let viewType = this.props.location.pathname.slice(this.props.ProductName.length + 2)
		viewType = viewType.substr(0, viewType.indexOf("/"))
		let strToMatch = viewType + "/" + this.state.datasetID + "/"
		let viewID = this.props.location.pathname.slice(this.props.ProductName.length + strToMatch.length + 2)
		let content = "default"
		switch (viewType.toUpperCase()){
			case "DASHBOARD":
			content = "Dashboard"
			break
			case "LIST":
			content = "list"
			break
			case "MATRIX":
			content = "matrix"
			break
			case "BROWSER":
			content = "browser"
			break
			default:
			content ="Dashboard"
			break
		}
		const classNames = cn("ToolbarContainer", content)
		this.setState({
			toolbarType: content,
			classNames: classNames,
			viewID: viewID,
			selectedSheetID: viewID
		})
	  }
	  OpenHelp(){
		  window.open("https://youtu.be/ScKw2NF27OU", "_blank")
  
	  }
	  GetNewAppData(){
		  this.props.callbackFromParent()
	  }
	

	render() {
		const {
		  sheetNames,
		  defaultSheet,
		  classNames,
		  datasetName,
		  RecordCount,
		  companyName,
		  selectedSheetID,
		  toolbarType,
		  UserName,
		  viewID,
		  ProductName,
		  FullProductPath,
		  datasetDetails,
		  FieldArray,
		  DetailFields,
		  TitleViewField,
		  appURL
		} = this.state
		return (
		<div className={classNames}>
			<div className="windowHeader">
					<div className="vp-iconSection" style={{display: "inline-block"}}>
					<div className="vp-LargeAppIcon" onClick={() => this.GetNewAppData()}></div>
						<div className="AppIconLabel" style={{display: "inline-block"}}><span className="Bold">{ProductName}</span> <span className="Colorized">Dashboard</span></div>
				</div>
				<div className="Spacer">{RecordCount} records</div>
				<div className="UserAccountHelpSection">
						<div className="UserAccountButton" style={{display: "inline-block"}}>
							<span className="UserName" style={{display: "inline-block"}}>{UserName}</span>
							<div className="vp-icon-16 SmallPersonIcon" style={{display: "inline-block"}} title="User Account"></div>
						
					</div>
					<span className="Spacer">|</span>
						<div className="vp-icon-16 vp-icon-Help-16 vp-icon-question" style={{display: "inline-block", margin: "0px 4px", cursor: "pointer"}} title="View Dashboard Demo on YouTube" onClick={() => this.OpenHelp()}></div>
				</div>
			</div>
			<SheetMenuContainer appURL={appURL} ProductName={this.state.ProductName} FullProductPath={FullProductPath} datasetID={this.state.datasetID} selectedSheetID={this.state.selectedSheetID} datasetDetails={datasetDetails} FieldArray={FieldArray} DetailFields={DetailFields} TitleViewField={TitleViewField}></SheetMenuContainer>
			<VPToolbarMenu ProductName={this.state.ProductName} shortSummary={this.state.shortSummary} ContactInfo={this.state.ContactInfo} ContactName={this.state.ContactName} UserName={this.state.UserName} ReportDate={this.state.ReportDate} toolbarType={toolbarType}></VPToolbarMenu>
		</div>
		)
	}
}
export default withRouter(Toolbars)